;(function (angular, _) {
  'use strict'

  class ClientAccountErrorController {
    // DI
    $q
    creditNoteManager
    entityManager
    invoiceManager
    snackService
    // Bindings
    errors = []
    // Locals
    loading = false
    parsedErrors = []

    constructor (
      // Angular
      $q,
      // Libs
      // Managers
      CreditNoteManager, EntityManager, InvoiceManager,
      // Services
      SnackService
      // Const
      // Resolved
    ) {
      this.$q = $q
      this.entityManager = EntityManager
      this.creditNoteManager = CreditNoteManager
      this.invoiceManager = InvoiceManager
      this.snackService = SnackService
    }

    /**
     * Lifecycle hook
     * @param changes {angular.changes}
     */
    $onChanges (changes) {
      if (changes?.errors?.currentValue) {
        this.loading = true
        this.parseErrors(changes.errors.currentValue)
          .then((parsed) => {
            this.parsedErrors = parsed
          }).finally(() => {
            this.loading = false
          })
      }
    }

    fixError (error, index) {
      const { invoices, creditNotes, client } = error
      return client.save().then(({ data }) => {
        return this.$q.all([
          this.fixElements(invoices, { account: data.account }, 'invoice'),
          this.fixElements(creditNotes, { account: data.account }, 'creditnote')
        ])
      })
        .then(() => {
          this.parsedErrors.splice(index, 1)
          this.snackService.snack({
            text: 'Compte client ajouté',
            delay: 5000
          })
          if (this.parsedErrors.length === 0) {
            this.allFixed()
          }
        })
    }

    /**
     * Fix given elements for given model
     * @private
     * @param keys {string[]} ID list
     * @param entity {Entity} Updated entity
     * @param model {'invoice' | 'creditnote'}
     * @return {Promise<*>}
     */
    fixElements (keys, entity, model = 'invoice') {
      let manager
      switch (model.toLowerCase()) {
        case 'invoice':
          manager = this.invoiceManager
          break
        case 'creditnote':
          manager = this.creditNoteManager
          break
      }
      return manager.updateClient(keys, entity)
    }

    /**
     * Get entities associated to errors and then group errors by entity
     * @private
     * @param errors
     * @return {Promise<{entity: Entity, error: error}>}
     */
    parseErrors (errors) {
      const entities = [...new Set(errors.map(({ data }) => data.client))]
      const query = this.entityManager.query({
        conditions: {
          _id: { $in: entities }
        },
        archived: 'both',
        select: '__t label number address number type'
      })
      return this.entityManager.post(query).then(({ data }) => {
        return data.map((entity) => {
          const invoices = errors
            .filter((e) => e.data.client === entity._id && !e.data.isCreditNote)
            .map((e) => e.data.invoice)
          const creditNotes = errors
            .filter((e) => e.data.client === entity._id && !!e.data.isCreditNote)
            .map((e) => e.data.invoice)
          return {
            client: entity,
            invoices,
            creditNotes
          }
        })
      })
    }
  }

  ClientAccountErrorController.$inject = [
    // Angular
    '$q',
    // Libs
    // Managers
    'CreditNoteManager', 'EntityManager', 'InvoiceManager',
    // Services
    'SnackService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('clientAccountError', {
      bindings: {
        errors: '<',
        allFixed: '&'
      },
      templateUrl: '/app/common/components/ledger-error-handler/client-account-error/client-account-error.template.html',
      controller: ClientAccountErrorController
    })
})(window.angular, window._)
